<div class="py-4 px-2" style="padding-bottom: 50px !important">
  <div class="pb-3">
    <h2 *ngIf="mode.toString() == 'cloneMode' || mode == 2">Cloning {{cloneUserName}}</h2>
    <h2 *ngIf="mode.toString() == 'editMode' || mode == 0"> Edit {{userProfile.username}}</h2>
    <h2 *ngIf="mode.toString() == 'createMode' || mode == 1">Create User</h2>
  </div>
  <div *ngIf="mode.toString() != 'editMode' && mode != 0" class="d-flex justify-content-between flex-wrap-reverse pt-1">
    <div class="md-dropdown pb-2">
      <p-dropdown #dd [options]="userSelectOptions" [(ngModel)]="userSelect" (onChange)="cloneUser('cloneMode', $event.value)" [filter]="true" filterBy="label, value" placeholder="Select a user to clone" class="w-25"></p-dropdown>
      <ng-container *ngIf="loadingAllUsers">
        <span role="status" class="spinner-border spinner-border-sm"></span>
      </ng-container>
    </div>
  </div>

  <ul class="nav nav-tabs" id="myTab">
    <li class="active nav-item">
      <a class=" nav-link active" href="#profile" data-toggle="tab" role="tab" aria-controls="profile" aria-selected="true">Profile <span *ngIf="mode != 0 && mode.toString() != 'editMode'  " class="text-danger"> *</span></a>
    </li>
    <li *ngxPermissionsOnly="['SUPERADMIN','CONTROLPANELADMIN']" class=" nav-item" (click)="refreshGroups()">
      <a class="nav-link" href="#permissions" data-toggle="tab" role="tab" aria-controls="permissions" aria-selected="false">Groups<span *ngIf="mode != 0 && mode.toString() != 'editMode'  " class="text-danger"> *</span></a>
    </li>
    <li *ngxPermissionsOnly="['FieldsTree']" class=" nav-item" (click)="refreshFieldsACLChild()">

      <a class="nav-link" href="#fieldsACL" data-toggle="tab" role="tab" aria-controls="fieldsACL" aria-selected="false">Field Access</a>

    </li>
    <li *ngxPermissionsOnly="['WellsReport']" class=" nav-item" (click)="refreshWellsACLChild()">

      <a class="nav-link" href="#wellsACL" data-toggle="tab" role="tab" aria-controls="wellsACL" aria-selected="false">Well Report Access</a>

    </li>
    <li *ngxPermissionsOnly="['ReportsTree']" class=" nav-item" (click)="refreshReportsACLChild()">

      <a class="nav-link" href="#reportsACL" data-toggle="tab" role="tab" aria-controls="reportsACL" aria-selected="false">Report Access</a>

    </li>
    <li *ngxPermissionsOnly="['ExpenditureFields']" class=" nav-item" (click)="refreshReportsACLChild()">

      <a class="nav-link" href="#fieldsExpendituresACL" data-toggle="tab" role="tab" aria-controls="fieldsExpendituresACL" aria-selected="false"> Field Expenditures Access</a>

    </li>

  </ul>

  <div class="tab-content" id="myTabContent">

    <div class="tab-pane fade show cp-tab-panel active in" role="tabpanel" aria-labelledby="profile-tab" id="profile">
      <div *ngIf="!isLoading">
        <div *ngIf="profileMessage" class="{{saveChangesAlertClass}} " style="margin-top:15px;" role="alert" id="profileMessageBox">
          <strong>Attention!</strong> {{profileMessage}}
        </div>
        <form [formGroup]="singleUserFrm" class="form-horizontal" (change)="hasChangedTrue()">

          <div class="form-group row">
            <div class="col-md-6" *ngIf="mode == 0 || mode.toString() == 'editMode'">
              <label for="staticEmail" class="form-control-label ">Email </label>
              <input class="form-control" type="email" disabled [ngModel]="userProfile.email" [ngModelOptions]="{standalone: true}" />
            </div>
            <div class="col-md-6 d-flex align-items-end" *ngIf="showManualReset">
              <button type="button" class="btn btn-outline-primary" data-toggle="modal" data-target="#passwordmodal">Password Manual Reset</button>
            </div>
          </div>

          <div class="form-group row">
            <div class="col-sm-12">
              <label for="fullname" class="form-control-label">Full Name<span *ngIf="mode != 0 && mode.toString() != 'editMode'" class="text-danger"> *</span></label>
              <input type="text" class="form-control" id="fullname" formControlName="fullname" autocomplete="off" name="fullname" />
            </div>
          </div>

          <div class="form-group row" *ngIf="mode != 0 && mode.toString() != 'editMode'">
            <div class="col-md-6">
              <label for="pa" class="form-control-label">Username<span class="text-danger"> *</span></label>
              <input type="text" class="form-control" id="cuUsername" formControlName="username" autocomplete="off" name="username" />
              <div class="alert alert-danger" role="alert" *ngIf="singleUserFrm.controls['username'].invalid">
                Please enter a valid username.<br />
              </div>
            </div>

            <div class="col-md-6">
              <label for="email" class="form-control-label">Email<span class="text-danger"> *</span></label>
              <input type="email" class="form-control" id="email" formControlName="email" autocomplete="off" requird name="email" />
              <div class="alert alert-danger" role="alert" *ngIf="singleUserFrm.controls['email'].invalid">
                Please make sure this is a valid email address, with no spaces.<br />
              </div>
            </div>
          </div>

          <div class="form-group row" *ngIf="Q_AVisible">
            <div class="col-md-6">
              <label for="pq" class="form-control-label">Password Question<span *ngIf="mode != 0 && mode.toString() != 'editMode'" class="text-danger"> *</span></label>
              <input type="text" class="form-control" id="passwordQuestion" formControlName="passwordQuestion" autocomplete="off" name="passwordQuestion" />
            </div>

            <div class="col-md-6">
              <label for="pa" class="form-control-label">Password Answer<span *ngIf="mode != 0 && mode.toString() != 'editMode'" class="text-danger"> *</span></label>
              <input type="text" class="form-control" id="passwordAnswer" formControlName="passwordAnswer" autocomplete="off" name="passwordAnswer" />
            </div>
          </div>

          <div class="form-group row" *ngIf="mode != 0 && mode.toString() != 'editMode'">
            <div class="col-md-6">
              <label for="cupassword" class="form-control-label">Password</label>
              <div class="input-group">
                <input type="{{passwordType}}" class="form-control" id="cuPassword" formControlName="password" autocomplete="new-password" name="cupassword" placeholder="password1 - leave empty for default" />
                <div class="input-group-append">
                  <button class="btn btn-secondary" type="button" (click)="showPassword()" title="Reveal password"><i class="far fa-eye"></i></button>
                </div>
              </div>
              <div class="alert alert-danger" role="alert" *ngIf="singleUserFrm.controls['password'].invalid">
                <small>
                  Please make sure the password is at least 8 characters long and contains the following:<br />
                  1 number,<br />
                  1 uppercase letter,<br />
                  1 lowercase letter,<br />
                  1 special character<br />
                </small>
              </div>
              <div class="alert alert-danger" role="alert" *ngIf="singleUserFrm.controls['password'].dirty && singleUserFrm.controls['rePassword'].dirty &&
                     singleUserFrm.controls['password'].value != singleUserFrm.controls['rePassword'].value && singleUserFrm.controls['password'].value != '' && singleUserFrm.controls['rePassword'].value != ''">
                Please make sure that both password inputs match.
              </div>
            </div>
            <div class="col-md-6">
              <label for="rePassword" class="form-control-label">Re-enter Password</label>
              <input type="{{passwordType}}" class="form-control" id="rePassword" autocomplete="off" name="rePassword" formControlName="rePassword" />
            </div>
          </div>

          <div class="form-group row">
            <div class="col-md-12">
              <label for="comment" class="form-control-label">Comments</label>
              <input type="text" class="form-control" id="comment" formControlName="comment" autocomplete="off" name="comment" />
            </div>
          </div>

          <div class="form-group" *ngxPermissionsOnly="['SUPERADMIN']">
            <div class="form-check" *ngIf="showFirstTime">
              <input class="form-check-input big-checkbox" type="checkbox" id="firstTime" formControlName="firsttime" autocomplete="off" name="firsttime">
              <label class="form-check-label pl-2 pt-1" for="firstTime">
                Reset password at next login
              </label>
            </div>
          </div>

          <div class="form-group row" *ngxPermissionsOnly="['SUPERADMIN','CONTROLPANELADMIN']">
            <div class="col-md-6">
              <h6><strong>Portal Access</strong></h6>
              <label class="switch">
                <input type="checkbox" id="CPAccess" (click)="checkUserName($event)" [checked]="userProfile.hasPortalAccess? true : false" formControlName="hasPortalAccess">
                <span class="slider round"></span>
              </label>
            </div>
            <div class="col-md-6">
              <h6><strong>Productioneer App Access</strong></h6>
              <label class="switch">
                <input type="checkbox" id="ProAccess" formControlName="isApproved" [checked]="userProfile.isApproved ? true : false">
                <span class="slider round"></span>
              </label>
            </div>
          </div>

          <div *ngIf="mode == 0 || mode.toString() == 'editMode'">

            <div class="form-group row">
              <div class="col-md-6">
                <label for="lastact" class="form-control-label">Last Activity Date</label>
                <h6 id="lastact" name="lastActivityDate">{{ checkDate(userProfile.lastActivityDate)}}</h6>
              </div>

              <div class="col-md-6">
                <label for="lastlog" class="form-control-label">Last Login Date</label>
                <h6 id="lastlog" name="lastLoginDate">{{checkDate(userProfile.lastLoginDate)}}</h6>
              </div>

            </div>
            <div class="form-group row">
              <div class="col-md-6">
                <label for="lastpass" class="form-control-label">Last Password Changed Date</label>
                <h6 id="lastpass" name="lastPasswordChangedDate">{{checkDate(userProfile.lastPasswordChangedDate)}}</h6>

              </div>

              <div class="col-md-6">
                <label for="creation" class="form-control-label">Creation Date</label>
                <h6 id="creation" name="creationDate">{{checkDate(userProfile.creationDate)}}</h6>
              </div>
            </div>

          </div>



          <div class="form-group row">
            <div class="col-md-3">
              <div class="loading-indicator login-btn-container" *ngIf="!submitted && (mode == 0 || mode.toString() == 'editMode')">
                <button type="submit" [disabled]="singleUserFrm.pristine || singleUserFrm.invalid || submitDisable() " (click)="saveSingleUserProfileChanges(singleUserFrm)" class="btn btn-primary ">Save Changes</button>
              </div>

              <div class="loading-indicator login-btn-container" *ngIf="submitted && (mode == 0 || mode.toString() == 'editMode')">
                <button class="btn  btn-danger "><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Submitting...</button>
              </div>
            </div>

          </div>
        </form>
      </div>
      <div style="width:100%" *ngIf="isLoading">
        <div class="spinner-border" style="width: 3rem; height: 3rem; display:flex;margin-left:auto;margin-right:auto;" role="status"></div>
      </div>
    </div>

    <div *ngxPermissionsOnly="['SUPERADMIN','CONTROLPANELADMIN']" class="tab-pane fade cp-tab-panel" role="tabpanel" aria-labelledby="permissions-tab" id="permissions">
      <div *ngIf="!groupLoading">
        <input id="groupsearch" [(ngModel)]="search" class="form-control filter-input" style="margin-bottom:20px;" placeholder="Search by Group Name" />
        <form>
          <div class="form-row">

            <div class="form-group col-md-6">
              <label for="avaTable" class="form-control-label">Available Groups {{avaCompanyGroups.length}} <i class="fas fa-sort" (click)="orderList('groupName','ga')"></i></label>
              <div style="max-height:500px;overflow-y:scroll;" *ngIf="avaCompanyGroups.length > 0">
                <table class=" table table-hover" id="avaTable" name="avaTable">
                  <tr *ngFor="let groups of avaCompanyGroups | groupsFilter:search: dummbyValue1;let i = index">
                    <td>{{groups.groupName}} </td>
                    <td style="width:60px;"><button type="button" class="btn btn-outline-success" (click)="changeGroupAssoc(groups,true , i)"><i class='{{groups.lockIcon}}'></i></button></td>
                  </tr>
                </table>
              </div>
              <div *ngIf="avaCompanyGroups.length == 0" class="alert alert-info" role="alert">
                No groups available.
              </div>
            </div>

            <div class="form-group col-md-6">
              <label class="form-control-label" for="ownedTable">Owned Groups {{ownedCompanyGroups.length}} <i class="fas fa-sort" (click)="orderList('groupName','go')"></i></label>
              <div style="max-height:500px;overflow-y:scroll;" *ngIf="ownedCompanyGroups.length > 0">
                <table class=" table table-hover" id="ownedTable" name="ownedTable">
                  <tr *ngFor="let groups of ownedCompanyGroups | groupsFilter:search : dummbyValue2;let i = index">

                    <td>{{groups.groupName}} </td>
                    <td style="width:60px;"><button type="button" class="btn btn-outline-danger" (click)="changeGroupAssoc(groups,false , i)"><i class='{{groups.lockIcon}}'></i></button></td>
                  </tr>
                </table>
              </div>
              <div *ngIf="ownedCompanyGroups.length == 0" class="alert alert-info" role="alert">
                No groups associated.
              </div>
            </div>
          </div>

        </form>
      </div>
      <div *ngIf="groupLoading" class="spinner-border" style="width: 3rem; height: 3rem; display:flex;margin-left:auto;margin-right:auto;" role="status"></div>
      <div style="width:100%">
      </div>
    </div>

    <div *ngxPermissionsOnly="['FieldsTree']" class="tab-pane fade cp-tab-panel" role="tabpanel" aria-labelledby="fieldsACL-tab" id="fieldsACL">
      <fields-acl #fieldsACLTemp *ngIf="userProfile2 != null" [user]="returnUsername()" [mode]="mode" (hasChangedTrue)="hasChangedTrue()" (hasChangedFalse)="hasChangedFalse()"></fields-acl>
    </div>

    <div *ngxPermissionsOnly="['WellsReport']" class="tab-pane fade cp-tab-panel" role="tabpanel" aria-labelledby="wellsACL-tab" id="wellsACL">
      <wells-acl #wellsACLTemp *ngIf="userProfile2 != null" [user]="returnUsername()" [mode]="mode" (hasChangedTrue)="hasChangedTrue()" (hasChangedFalse)="hasChangedFalse()"></wells-acl>
    </div>

    <div *ngxPermissionsOnly="['ReportsTree']" class="tab-pane fade cp-tab-panel" role="tabpanel" aria-labelledby="reportsACL-tab" id="reportsACL">
      <reports-acl *ngIf="userProfile2 != null" [user]="returnUsername()" [mode]="mode" (hasChangedTrue)="hasChangedTrue()" (hasChangedFalse)="hasChangedFalse()"></reports-acl>
    </div>

    <div *ngxPermissionsOnly="['ExpenditureFields']" class="tab-pane fade cp-tab-panel" role="tabpanel" aria-labelledby="fieldsExpendituresACL-tab" id="fieldsExpendituresACL">
      <fieldsExpenditures-acl *ngIf="userProfile2 != null" [user]="returnUsername()" [mode]="mode" (hasChangedTrue)="hasChangedTrue()" (hasChangedFalse)="hasChangedFalse()"></fieldsExpenditures-acl>
    </div>

    <div class="tab-pane fade cp-tab-panel container  page" role="tabpanel" aria-labelledby="setting-tab" id="setting">
      TODO: Add Settings

    </div>

  </div>

</div>
<div class="modal-footer" style="justify-content:flex-start">
  <div class="loading-indicator login-btn-container" *ngIf="!submitted && (mode != 0 && mode.toString() != 'editMode')">

    <button type="submit" id="CreateSubmitButton" title="" [disabled]="submitDisableCreate() || singleUserFrm.pristine || singleUserFrm.invalid  " (click)="createUser()" class="btn btn-primary ">Create User <span *ngIf="submitDisableCreate()" class="fas fa-question-circle" title="{{createUserMessage}}"></span></button>

  </div>
  <div class="loading-indicator login-btn-container" *ngIf="submitted && (mode != 0 && mode.toString() != 'editMode') ">
    <button class="btn  btn-danger "><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Submitting...</button>
  </div>
</div>
<div class="modal fade" id="passwordmodal" tabindex="-1" role="dialog" aria-labelledby="passwordmodal" aria-hidden="true" (blur)="modalLostFocus('passwordmodal',null)">
  <manual-password-reset [UserPasswordReset]="userProfile"></manual-password-reset>
</div>


